import { z } from "zod/v4";
import {
  CameraSubject,
  ClientApiFeaturePathParams,
  SingleResponse,
  defineResource,
  defineEndpoint,
} from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";

export type ListLivestreamsPathParams = ClientApiFeaturePathParams;

/**
 * Query parameters for list livestreams request.
 */
export const ListLivestreamsQueryParams = z.object({
  format: z.enum(["http-mp4", "mjpg"]).optional(),
});

export type ListLivestreamsQueryParams = z.output<typeof ListLivestreamsQueryParams>;

export const LivestreamUrlInfo = z.object({
  format: z.enum(["http-mp4", "mjpg"]),
  url: z.string(),
  timeoutSeconds: z.number(),
});

export type LivestreamUrlInfo = z.output<typeof LivestreamUrlInfo>;

export const LivestreamItem = z.object({
  subject: CameraSubject,
  streams: z.array(LivestreamUrlInfo),
});

export type LivestreamItem = z.output<typeof LivestreamItem>;

export const ListLivestreamsResponse = SingleResponse(LivestreamItem);

export type ListLivestreamsResponse = z.output<typeof ListLivestreamsResponse>;

// ==================== Resources & Endpoints ====================

export const livestreamsResource = defineResource({
  feature: FEATURE_NAME,
  resource: "livestreams",
});

export const listLivestreamsEndpoint = defineEndpoint(livestreamsResource, {
  responseSchema: ListLivestreamsResponse,
  querySchema: ListLivestreamsQueryParams,
});
